import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-4" }
const _hoisted_2 = { class: "ml-4" }

import { Co2QuizQuestion } from '@/models/co2-quiz.model';
import { PropType } from 'vue';
import { Category } from '@/models/category.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizOverview',
  props: {
  data: {
    type: Object as PropType<{
      questions: Co2QuizQuestion[];
      categories: Category[];
    }>,
    required: true,
  },
},
  setup(__props) {



function getQuestionAndCategories(
  categories: Category[],
  questions: Co2QuizQuestion[],
  parentCategoryId: number | null,
): { category: Category; questions: Co2QuizQuestion[] }[] {
  return [...categories]
    .filter((c) =>
      parentCategoryId
        ? c.parentCategory?.id === parentCategoryId
        : !c.parentCategory,
    )
    .sort((a, b) => a.index - b.index)
    .map((category) => {
      return {
        category,
        questions: questions.filter((q) =>
          q.categories.map((c) => c.id).includes(category.id),
        ),
      };
    });
  // .filter((v) => v.questions.length);
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Co2 quiz overview", -1)),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getQuestionAndCategories(
            __props.data.categories,
            __props.data.questions,
            null,
          ), (cat) => {
              return (_openBlock(), _createElementBlock("li", {
                key: cat.category.id
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(cat.category.title), 1),
                  (cat.questions.length)
                    ? (_openBlock(), _createBlock(_component_v_card, {
                        key: 0,
                        elevation: "4",
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.questions, (q) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: q.id
                                }, _toDisplayString(q.title), 1))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getQuestionAndCategories(
                __props.data.categories,
                __props.data.questions,
                cat.category.id,
              ), (cat2) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cat2.category.id
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(cat2.category.title), 1),
                      (cat2.questions.length)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            elevation: "4",
                            class: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat2.questions, (q) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: q.id
                                    }, _toDisplayString(q.title), 1))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getQuestionAndCategories(
                    __props.data.categories,
                    __props.data.questions,
                    cat2.category.id,
                  ), (cat3) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: cat3.category.id
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(cat3.category.title), 1),
                            (cat3.questions.length)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 0,
                                  elevation: "4",
                                  class: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat3.questions, (q) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            key: q.id
                                          }, _toDisplayString(q.title), 1))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})